module.exports = __webpack_public_path__ + "img/ValideWhite.63f5e417.svg";